module.exports = __webpack_public_path__ + "img/3.0afc9b35.svg";